// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25Buc","left":"styles_left__3unWM"};